import { Autocomplete, TextField } from "@mui/material";
import { autocompleteClasses } from "@mui/material";
import { useGlobalContext } from "@root/context";
import equal from "fast-deep-equal/react";
import { useEffect, useState } from "react";
import type { IAddParticipantFilters, IFilterInputProps } from "./types";

export const FilterTeam = ({ value, dispatch }: IFilterInputProps<IAddParticipantFilters["teams"]>) => {
  const { user } = useGlobalContext();
  const [localValue, setLocalValue] = useState(value);

  const handleDispatch = () => {
    if (!equal(localValue, value)) {
      dispatch({ type: "teams", payload: localValue });
    }
  };

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <Autocomplete
      disableCloseOnSelect
      onBlur={handleDispatch}
      getOptionLabel={(options) => options.name}
      options={user.organisation.teams ?? []}
      isOptionEqualToValue={(option, value) => option._id === value._id}
      value={localValue}
      multiple
      onChange={(_, values, reason) => {
        if (reason === "removeOption") {
          dispatch({ type: "teams", payload: values });
        }
        setLocalValue(values);
      }}
      limitTags={1}
      renderInput={(params) => <TextField {...params} label="Structure" size="small" />}
      slotProps={{
        chip: {
          color: "yellow",
          size: "small",
          sx: { [`&.${autocompleteClasses.tag}`]: { mt: "1px", mb: 0 } },
        }
      }}
    />
  );
};
